import { Suspense } from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import LaunchingSoon from './components/LaunchingSoon';
import AskJeevesAi from './components/AskJeevesAi';
import PropertiesByPhone from './components/PropertiesByPhone';
import PatentContextProvider from './context/PatentContextProvider';
import PortobelloMarketplace from './components/Portobello';
import AccessU2 from './components/AccessU2';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Pillar from './components/FivePillars';
import MobileBoomerang from './components/MobileBoomerang';
import YourFrontOffices from './components/YourFrontOffices';
import PatentCompanies from './components/PatentCompanies';
import PatentAttorneys from './components/Patentattorneys';

function App() {
  return (
    <div>
      <PatentContextProvider>
        <Router>
          <Routes>
            <Route path='/' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <LaunchingSoon /></Suspense>} />
            <Route path='/seven-pillars' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Pillar /></Suspense>} />

            {/* <Route
              path="/askJeeves"
              element={
                <Suspense fallback={<div className="h-screen bg-white">Loading...</div>}>
                  <AskJeevesAi />
                </Suspense>
              }
            />
            <Route path="/properties-by-phone" element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <PropertiesByPhone /></Suspense>} />
            <Route path="/coming-soon" element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <LaunchingSoon /></Suspense>} />

            <Route path="/portobello-marketplace" element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <PortobelloMarketplace /></Suspense>} />
            <Route path="/AccessU2" element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><AccessU2 /></Suspense>} />
            <Route path="/Mobileboomerang" element={<Suspense fallback={<div className='h-screen bg-white'>Loading...</div>}><MobileBoomerang /></Suspense>} />
            <Route path="/yourfrontoffices" element={<Suspense fallback={<div className='h-screen bg-white'>Loading...</div>}><YourFrontOffices /></Suspense>} />
            <Route path="/companies" element={<Suspense fallback={<div className='h-screen bg-white'>Loading...</div>}><PatentCompanies /></Suspense>} />
            <Route path="/attornies" element={<Suspense fallback={<div className='h-screen bg-white'>Loading...</div>}><PatentAttorneys /></Suspense>} /> */}
          </Routes>

        </Router>
      </PatentContextProvider>
    </div>
  );
}

export default App;
